import React, { PureComponent } from 'react';
import { bool, string, object } from 'prop-types';
import './index.less';

class Radio extends PureComponent {
  static defaultProps = {
    disable: true,
    label: '选择',
    className: '',
    style: {},
  };

  static propTypes = {
    disable: bool,
    label: string,
    className: string,
    style: object,
  };

  state = {
    checked: this.props.checked,
  };

  componentWillReceiveProps(nextProps) {
    const { checked } = nextProps;
    if (checked !== this.props.checked) {
      this.setState({ checked });
    }
  }

  _handleClick = () => {
    const { disable, clickEvent } = this.props;
    // const { checked } = this.state;
    if (disable) {
      // this.setState({ checked: !checked });

      clickEvent();
    }
  };

  render() {
    const { disable, name, label, className, style } = this.props;
    const { checked } = this.state;
    return (
      <div className={`radio ${className}`} {...style && { style }}>
        <input
          id={name}
          type="radio"
          checked={checked}
          onClick={this._handleClick}
        />
        <label
          htmlFor={name}
          aria-label={label}
          style={!disable ? { border: '0.02rem solid #d3d3d3' } : {}}
        />
        <span style={!disable ? { color: '#d3d3d3' } : {}}>{label}</span>
      </div>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/routes/routes/feeQuery/routes/detail/components/Radio/index.js